/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { useToast } from "@/hooks/use-toast";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import {
  companies,
  dsr_report_endpoint,
  retailers,
  users,
} from "@/services/global.services";
import { useEffect, useMemo, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import { format } from "date-fns";
import { getCurrentTimeZone } from "@/lib/utils";
import { getFileUrl } from "@/lib/get-file-url";

export const useMutations = () => {
  const timeZone = getCurrentTimeZone();

  const API_SERVICE = dsr_report_endpoint;
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const [companyData, _setCompanyData] = useState([]);
  const [tableColumn, setTableColumn] = useState([]);
  const [currentCompanyData, setCurrentCompanyData] = useState<any>([]);

  const { setSearchProgress, search } = useGlobalSearch();
  const { toast } = useToast();
  const [searchDebounced] = useDebouncedValue(search, 200);
  const [filter, setFilter] = useState({});

  const [dateFilter, setDateFilter] = useState([
    new DateObject().subtract(6, "days"),
    new DateObject(),
  ]);

  const [allRetailerList, setAllRetailerList] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState<string[]>([]);
  const [currentUser, setCurrentUser] = useState<any>(undefined);
  const [isAdmin, setIsAdmin] = useState<any>(false);

  const [paginationData, setPaginationData] = useState({
    page: 1,
    perPage: 10,
    totalItem: 1,
  });

  //On Load Component
  useEffect(() => {
    (async () => {
      await loadingList({ searchText: "" });
      await loadingRetailer();
      await loadUser();
      await loadingCompany();
      await wait(1000);
      setSkeltonLoading(false);
      setProcess(false);
    })();
  }, []);

  const loadUser = async () => {
    const payload = {
      data: {
        user_id: user_id,
        filter_by: {
          user_id: user_id,
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
    };
    const { data, error, message } = await apiServices(
      users.get,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    if (data?.result?.metadata?.users?.[0]) {
      const linked_customer =
        data?.result?.metadata?.users?.[0]?.linked_customer;
      setCurrentUser(data?.result?.metadata?.users?.[0]);
      if (linked_customer == "" || !linked_customer) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    }
  };

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        await loadingList({});
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    await loadingList({ page: prop });
    setProcess(false);
  };

  const onPerPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadingList({ perPage: prop, page: 1 });
    setProcess(false);
  };

  const permission: any = [];
  const onAction = async ({}: any) => {};

  const loadingRetailer = async (retailerProp?: any) => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
          ...retailerProp,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      retailers.get,
      "post",
      payload,
    );

    if (data) {
      setAllRetailerList(data.result.metadata?.[retailers.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const formatDate = (value: any) => {
    try {
      if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
        return value;
      }
      if (value?.toDate) {
        return format(value.toDate(), "dd-MM-yyyy");
      }
      return format(new Date(value as any), "dd-MM-yyyy");
    } catch (error) {
      return value;
    }
  };

  const onRetailerSelect = async (prop: any) => {
    setSelectedRecord(prop);
    setProcess(true);
    await loadingList({ selectedRetailerList: prop });
    setProcess(false);
  };

  const loadingList = async ({
    dateFilterData,
    selectedRetailerList,
    download = false,
  }: {
    perPage?: number;
    page?: number;
    filterReset?: boolean;
    makeFilter?: boolean;
    searchText?: string;
    dateFilterData?: any;
    selectedRetailerList?: any;
    download?: any;
  }) => {
    const finalDate = dateFilterData || dateFilter;

    const tempSelectedRecord =
      selectedRecord?.length > 0
        ? selectedRecord
        : allRetailerList?.map((item: any) => item.retailer_id);

    const payload: any = {
      data: {
        filter_by: {
          date_range: [formatDate(finalDate?.[0]), formatDate(finalDate?.[1])],
        },
        download: download,
        outlets: [],
      },
      company_id: company_id,
      user_id: user_id,
      timezone: timeZone,
    };

    if (isAdmin) {
      payload.data["outlets"] = selectedRetailerList || tempSelectedRecord;
    }

    const { data, error, message } = await apiServices<any>(
      API_SERVICE.get,
      "post",
      payload,
    );

    if (data && !download) {
      const listData = data.result.metadata?.[API_SERVICE.key];
      setListData(listData);

      setPaginationData((prev) => ({
        ...prev,
        totalItem: data?.result?.metadata?.total_records || 1,
      }));
    }

    if (data && download && data.result.metadata?.cash_balance_report) {
      const tempUrl = data.result.metadata.cash_balance_report;

      const finalUrl = await getFileUrl(tempUrl);

      console.log({ finalUrl });

      // Extract filename from URL
      const fileName = tempUrl.split("/").pop() || "download.xlsx";

      const link = document.createElement("a");
      link.href = finalUrl;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    return { data, error };
  };

  const filterRequest = async () => {
    setProcess(true);
    await loadingList({ makeFilter: true });
    setProcess(false);
  };

  const clearFilter = async () => {
    setFilter({});
    setProcess(true);
    await loadingList({ filterReset: true });
    setProcess(false);
  };

  const onDateChange = async (prop: any) => {
    setDateFilter(prop);
    setProcess(true);
    await loadingList({ dateFilterData: prop, page: 1 });
    setProcess(false);
  };

  const loadingCompany = async () => {
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      companies.get,
      "post",
      payload,
    );

    if (data) {
      setCurrentCompanyData(data.result.metadata[companies.key][0]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const downloadReport = async () => {
    setProcess(true);
    await loadingList({ download: true });
    setProcess(false);
  };

  return {
    skeltonLoading,
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    tableColumn,
    setTableColumn,
    companyData,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
    onDateChange,
    allRetailerList,
    setSelectedRecord,
    isAdmin,
    selectedRecord,
    currentUser,
    currentCompanyData,
    onRetailerSelect,
    downloadReport,
  };
};
